// Диалог "Как пользоваться"

import { Modal } from '../layout/Modal';
import { Calculator, Flame, Lightbulb, FileText } from 'lucide-react';

interface HelpDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function HelpDialog({ isOpen, onClose }: HelpDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Как пользоваться">
      {/* Режим потери напряжения */}
      <div className="modal-section">
        <h3 className="modal-section-title">
          <Calculator size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Режим «Потеря напряжения»
        </h3>
        <ol className="modal-list modal-list--numbered">
          <li>Выберите вкладку «Потеря напряжения»</li>
          <li>Введите номинальное напряжение (В)</li>
          <li>Введите ток нагрузки (А) или мощность (кВт)</li>
          <li>Укажите длину линии (м)</li>
          <li>Выберите или введите сечение проводника (мм²)</li>
          <li>Укажите коэффициент мощности (cosφ)</li>
          <li>Выберите тип сети, материал, тип нагрузки</li>
          <li>Нажмите «Рассчитать» для получения результатов</li>
          <li>Используйте «Подобрать сечение» для автоматического подбора</li>
          <li>Нажмите «Экспорт в DOCX» для сохранения отчёта</li>
        </ol>
      </div>

      {/* Режим нагрева */}
      <div className="modal-section">
        <h3 className="modal-section-title">
          <Flame size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Режим «Нагрев (длит. ток)»
        </h3>
        <ol className="modal-list modal-list--numbered">
          <li>Выберите вкладку «Нагрев»</li>
          <li>Введите расчётный ток (А)</li>
          <li>Выберите материал проводника (медь/алюминий)</li>
          <li>Выберите тип изоляции (ПВХ/СПЭ)</li>
          <li>Укажите способ прокладки</li>
          <li>Задайте температуру окружающей среды</li>
          <li>Укажите количество кабелей рядом (при прокладке пучком)</li>
          <li>Нажмите «Рассчитать» для получения результатов</li>
        </ol>
      </div>

      {/* Формулы */}
      <div className="modal-section">
        <h3 className="modal-section-title">
          <Lightbulb size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Формулы расчёта
        </h3>
        
        <div className="modal-subtitle">Потеря напряжения:</div>
        
        <div className="modal-formula">
          R = ρ × L / S
        </div>
        <p className="modal-section-text" style={{ marginTop: '-8px', marginBottom: '12px' }}>
          Активное сопротивление проводника
        </p>
        
        <div className="modal-formula">
          X = X₀ × Lкм
        </div>
        <p className="modal-section-text" style={{ marginTop: '-8px', marginBottom: '12px' }}>
          Реактивное сопротивление линии
        </p>
        
        <div className="modal-formula">
          ΔU = √3 × I × (R × cosφ + X × sinφ)
        </div>
        <p className="modal-section-text" style={{ marginTop: '-8px', marginBottom: '12px' }}>
          Потеря напряжения для 3-фазной сети
        </p>

        <div className="modal-subtitle">Допустимый ток:</div>
        
        <div className="modal-formula">
          Iдоп × kпопр ≥ Iрасч
        </div>
        <p className="modal-section-text" style={{ marginTop: '-8px' }}>
          Условие соответствия сечения по нагреву
        </p>
      </div>

      {/* Экспорт */}
      <div className="modal-section">
        <h3 className="modal-section-title">
          <FileText size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Экспорт результатов
        </h3>
        <p className="modal-section-text">
          После расчёта вы можете экспортировать результаты в формате DOCX (Microsoft Word).
          Документ содержит все введённые параметры, результаты расчёта и рекомендации.
        </p>
      </div>
    </Modal>
  );
}
